import './List.css.proxy.js';
/* src/components/List.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	mount_component,
	run_all,
	safe_not_equal,
	select_option,
	select_value,
	set_input_value,
	space,
	text,
	transition_in,
	transition_out
} from "../web_modules/svelte/internal.js";

import VirtualList from "./VirtualList.js";
import ListItem from "./ListItem.js";
import { topics } from "./topics.js";
import { debounce } from "./utils.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[14] = list[i][0];
	child_ctx[15] = list[i][1];
	return child_ctx;
}

// (54:4) {#each topicsList as [name, terms]}
function create_each_block(ctx) {
	let option;
	let t0_value = /*name*/ ctx[14] + "";
	let t0;
	let t1;
	let option_value_value;
	let mounted;
	let dispose;

	function click_handler() {
		return /*click_handler*/ ctx[10](/*terms*/ ctx[15]);
	}

	return {
		c() {
			option = element("option");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			option = claim_element(nodes, "OPTION", { value: true, class: true });
			var option_nodes = children(option);
			t0 = claim_text(option_nodes, t0_value);
			t1 = claim_space(option_nodes);
			option_nodes.forEach(detach);
			this.h();
		},
		h() {
			option.__value = option_value_value = /*terms*/ ctx[15];
			option.value = option.__value;
			attr(option, "class", "svelte-1egnpnc");
		},
		m(target, anchor) {
			insert(target, option, anchor);
			append(option, t0);
			append(option, t1);

			if (!mounted) {
				dispose = listen(option, "click", click_handler);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(option);
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div0;
	let input;
	let t0;
	let select;
	let option;
	let t1;
	let t2;
	let div1;
	let virtuallist;
	let current;
	let mounted;
	let dispose;
	let each_value = /*topicsList*/ ctx[3];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	virtuallist = new VirtualList({
			props: {
				items: /*filteredItems*/ ctx[2],
				component: ListItem
			}
		});

	return {
		c() {
			div0 = element("div");
			input = element("input");
			t0 = space();
			select = element("select");
			option = element("option");
			t1 = text("or pick a topic");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t2 = space();
			div1 = element("div");
			create_component(virtuallist.$$.fragment);
			this.h();
		},
		l(nodes) {
			div0 = claim_element(nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			input = claim_element(div0_nodes, "INPUT", { placeholder: true, class: true });
			t0 = claim_space(div0_nodes);
			select = claim_element(div0_nodes, "SELECT", { class: true });
			var select_nodes = children(select);
			option = claim_element(select_nodes, "OPTION", { value: true, class: true });
			var option_nodes = children(option);
			t1 = claim_text(option_nodes, "or pick a topic");
			option_nodes.forEach(detach);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(select_nodes);
			}

			select_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t2 = claim_space(nodes);
			div1 = claim_element(nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			claim_component(virtuallist.$$.fragment, div1_nodes);
			div1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(input, "placeholder", "Search for specific terms");
			attr(input, "class", "svelte-1egnpnc");
			option.__value = "";
			option.value = option.__value;
			attr(option, "class", "svelte-1egnpnc");
			attr(select, "class", "topics svelte-1egnpnc");
			if (/*selectValue*/ ctx[1] === void 0) add_render_callback(() => /*select_change_handler*/ ctx[11].call(select));
			attr(div0, "class", "controls svelte-1egnpnc");
			attr(div1, "class", "list svelte-1egnpnc");
		},
		m(target, anchor) {
			insert(target, div0, anchor);
			append(div0, input);
			set_input_value(input, /*inputValue*/ ctx[0]);
			append(div0, t0);
			append(div0, select);
			append(select, option);
			append(option, t1);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(select, null);
			}

			select_option(select, /*selectValue*/ ctx[1]);
			insert(target, t2, anchor);
			insert(target, div1, anchor);
			mount_component(virtuallist, div1, null);
			current = true;

			if (!mounted) {
				dispose = [
					listen(input, "input", /*input_input_handler*/ ctx[9]),
					listen(select, "change", /*select_change_handler*/ ctx[11]),
					listen(select, "change", /*onUpdateSelectValue*/ ctx[4])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*inputValue*/ 1 && input.value !== /*inputValue*/ ctx[0]) {
				set_input_value(input, /*inputValue*/ ctx[0]);
			}

			if (dirty & /*topicsList, onFilterByTerms*/ 40) {
				each_value = /*topicsList*/ ctx[3];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(select, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*selectValue, topicsList*/ 10) {
				select_option(select, /*selectValue*/ ctx[1]);
			}

			const virtuallist_changes = {};
			if (dirty & /*filteredItems*/ 4) virtuallist_changes.items = /*filteredItems*/ ctx[2];
			virtuallist.$set(virtuallist_changes);
		},
		i(local) {
			if (current) return;
			transition_in(virtuallist.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(virtuallist.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div0);
			destroy_each(each_blocks, detaching);
			if (detaching) detach(t2);
			if (detaching) detach(div1);
			destroy_component(virtuallist);
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const topicsList = topics.filter(d => d[0]).map(d => [d[0], d[1].join(",")]);
	console.log(topicsList);
	let { items = [] } = $$props;
	let selectValue = "";
	let inputValue = "";
	let searchString = "";
	let lastControlChanged = null;

	const updateSearchString = debounce(
		() => {
			lastControlChanged = "search";
			$$invalidate(7, searchString = inputValue.toLowerCase());
		},
		200
	);

	const onUpdateSelectValue = str => {
		$$invalidate(0, inputValue = str.target.value);
		console.log(str);
	};

	const onFilterByTerms = str => {
		$$invalidate(0, inputValue = str);
		$$invalidate(1, selectValue = str);
	};

	function input_input_handler() {
		inputValue = this.value;
		$$invalidate(0, inputValue);
	}

	const click_handler = terms => onFilterByTerms(terms);

	function select_change_handler() {
		selectValue = select_value(this);
		($$invalidate(1, selectValue), $$invalidate(0, inputValue));
		$$invalidate(3, topicsList);
	}

	$$self.$$set = $$props => {
		if ("items" in $$props) $$invalidate(6, items = $$props.items);
	};

	let searchTerms;
	let filteredItems;

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*inputValue*/ 1) {
			$: $$invalidate(1, selectValue = topicsList.find(([name, terms]) => terms == inputValue)
			? inputValue
			: "");
		}

		if ($$self.$$.dirty & /*inputValue*/ 1) {
			$: (inputValue, updateSearchString());
		}

		if ($$self.$$.dirty & /*searchString*/ 128) {
			$: $$invalidate(8, searchTerms = searchString.split(","));
		}

		if ($$self.$$.dirty & /*searchString, items, searchTerms*/ 448) {
			$: $$invalidate(2, filteredItems = searchString
			? items.filter(d => searchTerms.filter(term => d.searchString.toLowerCase().includes(term)).length)
			: items);
		}
	};

	return [
		inputValue,
		selectValue,
		filteredItems,
		topicsList,
		onUpdateSelectValue,
		onFilterByTerms,
		items,
		searchString,
		searchTerms,
		input_input_handler,
		click_handler,
		select_change_handler
	];
}

class List extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { items: 6 });
	}
}

export default List;
//# sourceMappingURL=List.js.map
